const cards = [
  {
    id: 1,
    title: '4K 超清画质 · 尽享视觉盛宴',
    tag: '观影体验',
    desc: '天堂影院全线支持 1080P 至 4K 超清画质播放，搭配多线路智能调度技术，确保每一帧都清晰流畅。无论大屏电视还是移动设备，都能获得影院级视觉享受。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20high%20definition%20film%20projection%20with%20warm%20golden%20light%20on%20dark%20theater%20background%2C%20elegant%20home%20cinema%20setup%2C%20crystal%20clear%20image%20quality%2C%20dramatic%20lighting%2C%20premium%20viewing%20experience&width=700&height=420&seq=cards-01&orientation=landscape',
    icon: 'ri-4k-line',
    iconCls: 'bg-accent-100 text-accent-600',
  },
  {
    id: 2,
    title: '极速加载 · 告别缓冲等待',
    tag: '技术优势',
    desc: '采用全球 CDN 加速与智能预加载技术，影片秒开即播。自适应码率算法根据网络实时调整清晰度，弱网环境也能稳定流畅观影。',
    img: 'https://readdy.ai/api/search-image?query=Fast%20speed%20abstract%20visual%20with%20light%20trails%20on%20dark%20background%2C%20technology%20and%20performance%20theme%2C%20warm%20accent%20colors%2C%20sleek%20modern%20design%2C%20data%20stream%20aesthetic%2C%20minimalist%20tech%20composition&width=700&height=420&seq=cards-02&orientation=landscape',
    icon: 'ri-speed-up-line',
    iconCls: 'bg-primary-100 text-primary-600',
  },
  {
    id: 3,
    title: '海量片库 · 每日持续更新',
    tag: '内容规模',
    desc: '收录超过 20000 部高清电影资源，涵盖动作、悬疑、科幻、喜剧等全品类。片源团队 7×24 小时轮值更新，热门大片第一时间同步上线。',
    img: 'https://readdy.ai/api/search-image?query=Vast%20movie%20library%20wall%20with%20colorful%20film%20posters%20arranged%20artistically%20on%20dark%20background%2C%20organized%20collection%20aesthetic%2C%20warm%20lighting%20accents%2C%20cinematic%20atmosphere%2C%20archive%20style%20composition&width=700&height=420&seq=cards-03&orientation=landscape',
    icon: 'ri-film-line',
    iconCls: 'bg-secondary-100 text-secondary-600',
  },
  {
    id: 4,
    title: '纯净观影 · 零广告干扰',
    tag: '用户体验',
    desc: '天堂影院坚持全站无广告原则，无贴片、无弹窗、无强制跳转。打开页面即可直接观影，把每一秒都留给电影本身。',
    img: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20viewing%20space%20with%20soft%20ambient%20lighting%20on%20dark%20wall%2C%20peaceful%20atmosphere%2C%20no%20distractions%2C%20elegant%20simple%20interior%2C%20comfortable%20cinema%20experience%2C%20warm%20tones&width=700&height=420&seq=cards-04&orientation=landscape',
    icon: 'ri-shield-check-line',
    iconCls: 'bg-accent-100 text-accent-600',
  },
  {
    id: 5,
    title: '多端适配 · 随时随地观影',
    tag: '便捷访问',
    desc: '完美适配电脑、平板、手机等全终端设备。响应式界面设计确保不同屏幕尺寸下都有最佳观影布局，真正实现随时随地畅享高清电影。',
    img: 'https://readdy.ai/api/search-image?query=Multiple%20devices%20displaying%20movie%20content%20on%20dark%20background%2C%20phone%20tablet%20laptop%20harmonious%20arrangement%2C%20cross%20platform%20technology%2C%20warm%20screen%20glow%2C%20modern%20digital%20lifestyle%2C%20elegant%20composition&width=700&height=420&seq=cards-05&orientation=landscape',
    icon: 'ri-device-line',
    iconCls: 'bg-primary-100 text-primary-600',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            推荐专题
          </h2>
          <p className="text-sm text-foreground-400 max-w-[500px] mx-auto">
            了解天堂影院的核心优势与特色服务
          </p>
        </div>

        <div className="flex flex-col gap-5 md:gap-6">
          {cards.map((card, idx) => {
            const isEven = idx % 2 === 0;
            return (
              <article
                key={card.id}
                className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-5 md:gap-8 rounded-lg bg-background-200/60 border border-background-200/50 p-5 md:p-6 overflow-hidden group cursor-pointer hover:border-primary-500/20 transition-all duration-300`}
              >
                <div className="lg:w-[340px] shrink-0">
                  <div className="relative rounded-md overflow-hidden aspect-[16/10] bg-background-300">
                    <img
                      src={card.img}
                      alt={card.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-background-200/60 to-transparent"></div>
                  </div>
                </div>

                <div className="flex-1 flex flex-col justify-center">
                  <div className="flex items-center gap-2.5 mb-3">
                    <span className={`w-9 h-9 flex items-center justify-center rounded-lg ${card.iconCls}`}>
                      <i className={`${card.icon} text-base`}></i>
                    </span>
                    <span className="px-2 py-0.5 rounded-md bg-background-200 text-xs text-foreground-400 font-medium">
                      {card.tag}
                    </span>
                  </div>

                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-800 mb-2 group-hover:text-primary-500 transition-colors">
                    {card.title}
                  </h3>

                  <p className="text-sm text-foreground-400 leading-relaxed">
                    {card.desc}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}